import { useCheckout } from "../../context/CheckoutContext";
import { CheckoutFormStep } from "../CheckoutFormStep/CheckoutFormStep";
import { SpinnerLoader } from "../SpinnerLoader/SpinnerLoader";

export const CheckoutConfirmation = () => {
    //HOOKS
    const {
        checkoutLoading,
        checkoutError,
        postCheckout,
    } = useCheckout();

    return (
        <CheckoutFormStep
            step={3}
            title={"Review and order"}
        >
            <div className='checkout_delivery_continue_container'>
                {
                    checkoutLoading && (
                        <div style={{marginRight: 'auto'}}>
                            <SpinnerLoader />
                        </div>
                    )
                }
                <div className='checkout_input_container'>
                    {
                        checkoutError !== "" && (
                            <span>{checkoutError}</span>
                        )
                    }
                </div>
                
                <button disabled={checkoutLoading} onClick={postCheckout}>
                    Order now
                </button>
            </div>  
        </CheckoutFormStep>
    );
}